(function () {
  'use strict';

  var copyByLocale = {
    cs: ['Nastavení souborů cookie', 'Soubory cookie používáme pro fungování webu a s vaším souhlasem také k analýze návštěvnosti a zobrazování relevantní reklamy.'],
    pl: ["Ustawienia plików cookie", "Używamy plików cookie, aby ułatwić korzystanie ze strony, wyświetlać reklamy i analizować ruch."],
    da: ['Cookievalg', 'Vi bruger cookies til en bedre oplevelse, annoncering og analyse.'],
    de: ['Cookie-Einstellungen', 'Wir verwenden Cookies für ein besseres Erlebnis, Werbung und Analysen.'],
    en: ['Cookie preferences', 'We use cookies for a better experience, advertising and analytics.'],
    es: ['Preferencias de cookies', 'Usamos cookies para mejorar tu experiencia, la publicidad y el análisis.'],
    et: ['Küpsiste valikud', 'Kasutame küpsiseid parema kasutuskogemuse, reklaamide ja analüüsi jaoks.'],
    fi: ['Evästeasetukset', 'Käytämme evästeitä parempaan kokemukseen, mainontaan ja analytiikkaan.'],
    fr: ['Préférences de cookies', 'Nous utilisons des cookies pour améliorer votre expérience, la publicité et l’analyse.'],
    it: ['Preferenze cookie', 'Usiamo i cookie per migliorare l’esperienza, la pubblicità e l’analisi.'],
    nb: ['Innstillinger for informasjonskapsler', 'Vi bruker informasjonskapsler for en bedre opplevelse, annonsering og analyse.'],
    nl: ['Cookievoorkeuren', 'Wij gebruiken cookies voor een betere ervaring, advertenties en analyse.'],
    pt: ['Preferências de cookies', 'Usamos cookies para melhorar a experiência, a publicidade e a análise.'],
    ro: ['Preferințe privind cookie-urile', 'Folosim cookie-uri pentru funcționarea site-ului și, cu acordul tău, pentru publicitate relevantă și analiza traficului.'],
    sk: ['Nastavenia súborov cookie', 'Používame súbory cookie, aby sa vám stránka používala pohodlnejšie, a na reklamu a analýzu návštevnosti.'],
    sv: ['Cookieinställningar', 'Vi använder cookies för en bättre upplevelse, annonsering och analys.']
  };

  var preferenceCopyByLocale = {
    cs: ['Vyberte, jaké soubory cookie povolíte.', 'Jsou nezbytné pro fungování webu a košíku.', 'Pamatují si vaše nastavení.', 'Pomáhají zobrazovat relevantní reklamu.', 'Pomáhají nám zlepšovat web.'],
    pl: ["Wybierz, na jakie pliki cookie zezwalasz.", "Niezbędne do działania strony i koszyka.", "Zapamiętują Twoje ustawienia.", "Pomagają wyświetlać dopasowane reklamy.", "Pomagają nam ulepszać stronę."],
    da: ['Vælg hvilke cookies du vil tillade.', 'Nødvendige for siden og kurven.', 'Husker dine valg.', 'Hjælper med at vise relevante annoncer.', 'Hjælper os med at forbedre siden.'],
    de: ['Wähle aus, welche Cookies du erlaubst.', 'Erforderlich für Website und Warenkorb.', 'Speichert deine Einstellungen.', 'Hilft, relevante Werbung zu zeigen.', 'Hilft uns, die Website zu verbessern.'],
    en: ['Choose which cookies you allow.', 'Required for the site and cart.', 'Remembers your preferences.', 'Helps show relevant advertising.', 'Helps us improve the site.'],
    es: ['Elige qué cookies permites.', 'Necesarias para el sitio y el carrito.', 'Recuerda tus preferencias.', 'Ayuda a mostrar publicidad relevante.', 'Nos ayuda a mejorar el sitio.'],
    et: ['Vali, milliseid küpsiseid lubad.', 'Vajalikud saidi ja ostukorvi jaoks.', 'Jätab sinu valikud meelde.', 'Aitab näidata asjakohaseid reklaame.', 'Aitab meil saiti parandada.'],
    fi: ['Valitse sallimasi evästeet.', 'Tarvitaan sivustoon ja ostoskoriin.', 'Muistaa valintasi.', 'Auttaa näyttämään osuvia mainoksia.', 'Auttaa meitä parantamaan sivustoa.'],
    fr: ['Choisissez les cookies que vous autorisez.', 'Nécessaires au site et au panier.', 'Mémorise vos préférences.', 'Aide à afficher des publicités pertinentes.', 'Nous aide à améliorer le site.'],
    it: ['Scegli quali cookie consentire.', 'Necessari per il sito e il carrello.', 'Ricorda le tue preferenze.', 'Aiuta a mostrare pubblicità pertinenti.', 'Ci aiuta a migliorare il sito.'],
    nb: ['Velg hvilke informasjonskapsler du tillater.', 'Nødvendige for nettstedet og handlekurven.', 'Husker valgene dine.', 'Bidrar til å vise relevante annonser.', 'Hjelper oss med å forbedre nettstedet.'],
    nl: ['Kies welke cookies je toestaat.', 'Nodig voor de site en winkelwagen.', 'Onthoudt jouw voorkeuren.', 'Helpt relevante advertenties te tonen.', 'Helpt ons de site te verbeteren.'],
    pt: ['Escolha os cookies que permite.', 'Necessários para o site e o carrinho.', 'Recorda as suas preferências.', 'Ajuda a mostrar publicidade relevante.', 'Ajuda-nos a melhorar o site.'],
    ro: ['Alege ce categorii de cookie-uri permiți.', 'Necesare pentru funcționarea site-ului și a coșului.', 'Țin minte preferințele tale.', 'Ne ajută să afișăm reclame relevante.', 'Ne ajută să îmbunătățim site-ul.'],
    sk: ['Vyberte si, ktoré súbory cookie povolíte.', 'Nevyhnutné na fungovanie stránky a nákupného košíka.', 'Pamätajú si vaše nastavenia.', 'Pomáhajú zobrazovať relevantné reklamy.', 'Pomáhajú nám zlepšovať stránku.'],
    sv: ['Välj vilka cookies du tillåter.', 'Krävs för webbplatsen och varukorgen.', 'Kommer ihåg dina val.', 'Hjälper till att visa relevanta annonser.', 'Hjälper oss att förbättra webbplatsen.']
  };

  var uiCopyByLocale = {
    cs: ['Spravovat nastavení', 'Přijmout', 'Odmítnout', 'Přijmout vše', 'Odmítnout vše', 'Uložit', 'Nezbytné', 'Přizpůsobení', 'Marketing', 'Analytika', 'Zavřít'],
    pl: ["Zarządzaj ustawieniami", "Akceptuj", "Odrzuć", "Akceptuj wszystkie", "Odrzuć wszystkie", "Zapisz", "Niezbędne", "Personalizacja", "Marketing", "Analityka", "Zamknij"],
    da: ['Administrer valg', 'Accepter', 'Afvis', 'Accepter alle', 'Afvis alle', 'Gem', 'Nødvendige', 'Personalisering', 'Marketing', 'Analyse', 'Luk'],
    de: ['Einstellungen verwalten', 'Akzeptieren', 'Ablehnen', 'Alle akzeptieren', 'Alle ablehnen', 'Speichern', 'Erforderlich', 'Personalisierung', 'Marketing', 'Analyse', 'Schließen'],
    en: ['Manage preferences', 'Accept', 'Decline', 'Accept all', 'Decline all', 'Save', 'Required', 'Personalisation', 'Marketing', 'Analytics', 'Close'],
    es: ['Gestionar preferencias', 'Aceptar', 'Rechazar', 'Aceptar todo', 'Rechazar todo', 'Guardar', 'Necesarias', 'Personalización', 'Marketing', 'Análisis', 'Cerrar'],
    et: ['Halda valikuid', 'Nõustu', 'Keeldu', 'Nõustu kõigiga', 'Keeldu kõigest', 'Salvesta', 'Vajalikud', 'Isikupärastamine', 'Turundus', 'Analüütika', 'Sulge'],
    fi: ['Hallitse asetuksia', 'Hyväksy', 'Hylkää', 'Hyväksy kaikki', 'Hylkää kaikki', 'Tallenna', 'Välttämättömät', 'Personointi', 'Markkinointi', 'Analytiikka', 'Sulje'],
    fr: ['Gérer les préférences', 'Accepter', 'Refuser', 'Tout accepter', 'Tout refuser', 'Enregistrer', 'Nécessaires', 'Personnalisation', 'Marketing', 'Analyse', 'Fermer'],
    it: ['Gestisci preferenze', 'Accetta', 'Rifiuta', 'Accetta tutto', 'Rifiuta tutto', 'Salva', 'Necessari', 'Personalizzazione', 'Marketing', 'Analisi', 'Chiudi'],
    nb: ['Administrer valg', 'Godta', 'Avslå', 'Godta alle', 'Avslå alle', 'Lagre', 'Nødvendige', 'Personalisering', 'Markedsføring', 'Analyse', 'Lukk'],
    nl: ['Voorkeuren beheren', 'Accepteren', 'Afwijzen', 'Alles accepteren', 'Alles afwijzen', 'Opslaan', 'Vereist', 'Personalisatie', 'Marketing', 'Analyse', 'Sluiten'],
    pt: ['Gerir preferências', 'Aceitar', 'Recusar', 'Aceitar tudo', 'Recusar tudo', 'Guardar', 'Necessários', 'Personalização', 'Marketing', 'Análise', 'Fechar'],
    ro: ['Gestionează preferințele', 'Acceptă', 'Respinge', 'Acceptă toate', 'Respinge toate', 'Salvează', 'Necesare', 'Personalizare', 'Marketing', 'Analiză', 'Închide'],
    sk: ['Spravovať nastavenia', 'Prijať', 'Odmietnuť', 'Prijať všetky', 'Odmietnuť všetky', 'Uložiť', 'Nevyhnutné', 'Prispôsobenie', 'Marketing', 'Analytika', 'Zavrieť'],
    sv: ['Hantera inställningar', 'Acceptera', 'Avvisa', 'Acceptera alla', 'Avvisa alla', 'Spara', 'Nödvändiga', 'Personalisering', 'Marknadsföring', 'Analys', 'Stäng']
  };

  var countryLocaleByCode = {
    CZ: 'cs', PL: 'pl',
    AD: 'fr', AT: 'de', AU: 'en', CA: 'en', CH: 'de', DE: 'de', DK: 'da',
    EE: 'et', ES: 'es', FI: 'fi', FR: 'fr', GB: 'en', IE: 'en', IT: 'it',
    LI: 'de', MC: 'fr', NL: 'nl', NO: 'nb', NZ: 'en', PT: 'pt', RO: 'ro', SE: 'sv', SK: 'sk', US: 'en'
  };

  var consentTransferParam = 'nb_consent';
  var transferredConsentState = consumeTransferredConsent();
  var lastConsentState = null;

  function normalizeConsentFlag(value) {
    if (value === true || value === 'yes') return true;
    if (value === false || value === 'no') return false;
    return null;
  }

  function hasConsentDecision(state) {
    return !!state && [state.analytics, state.marketing, state.preferences].some(function (value) {
      return typeof value === 'boolean';
    });
  }

  function consentStateFromVisitor(customerPrivacy) {
    if (!customerPrivacy || typeof customerPrivacy.currentVisitorConsent !== 'function') return null;
    try {
      var consent = customerPrivacy.currentVisitorConsent() || {};
      var state = {
        analytics: normalizeConsentFlag(consent.analytics),
        marketing: normalizeConsentFlag(consent.marketing),
        preferences: normalizeConsentFlag(consent.preferences)
      };
      return hasConsentDecision(state) ? state : null;
    } catch (_readConsentError) {
      return null;
    }
  }

  function consentStateFromEvent(detail) {
    detail = detail || {};
    var state = {
      analytics: normalizeConsentFlag(
        typeof detail.analyticsAllowed === 'boolean' ? detail.analyticsAllowed : detail.analyticsProcessingAllowed
      ),
      marketing: normalizeConsentFlag(detail.marketingAllowed),
      preferences: normalizeConsentFlag(detail.preferencesAllowed)
    };
    return hasConsentDecision(state) ? state : null;
  }

  function encodeConsentState(state) {
    if (!hasConsentDecision(state)) return '';
    function flag(value) {
      return value === true ? '1' : value === false ? '0' : 'x';
    }
    return 'v1-' + flag(state.analytics) + flag(state.marketing) + flag(state.preferences);
  }

  function decodeConsentState(value) {
    var match = /^v1-([01x])([01x])([01x])$/.exec(String(value || ''));
    if (!match) return null;
    function flag(value) {
      return value === '1' ? true : value === '0' ? false : null;
    }
    var state = {
      analytics: flag(match[1]),
      marketing: flag(match[2]),
      preferences: flag(match[3])
    };
    return hasConsentDecision(state) ? state : null;
  }

  function consumeTransferredConsent() {
    try {
      var url = new URL(window.location.href);
      if (!url.searchParams.has(consentTransferParam)) return null;
      var state = decodeConsentState(url.searchParams.get(consentTransferParam));
      url.searchParams.delete(consentTransferParam);
      window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
      if (state) document.documentElement.classList.add('nb-cookie-consent-transfer-pending');
      return state;
    } catch (_consumeConsentError) {
      return null;
    }
  }

  function waitForCustomerPrivacy(onReady, onFailure) {
    var attempts = 0;
    var loadRequested = false;

    function poll() {
      var shopify = window.Shopify;
      var customerPrivacy = shopify && shopify.customerPrivacy;
      if (customerPrivacy) {
        onReady(customerPrivacy);
        return;
      }
      if (attempts >= 100) {
        if (onFailure) onFailure();
        return;
      }
      attempts += 1;

      if (shopify && typeof shopify.loadFeatures === 'function' && !loadRequested) {
        loadRequested = true;
        shopify.loadFeatures([
          { name: 'consent-tracking-api', version: '0.1' }
        ], function () {
          loadRequested = false;
          poll();
        });
        return;
      }
      window.setTimeout(poll, 50);
    }

    poll();
  }

  function consentStatesMatch(left, right) {
    if (!left || !right) return false;
    return ['analytics', 'marketing', 'preferences'].every(function (key) {
      return typeof right[key] !== 'boolean' || left[key] === right[key];
    });
  }

  function finishTransferredConsent(customerPrivacy) {
    var currentState = consentStateFromVisitor(customerPrivacy);
    if (!consentStatesMatch(currentState, transferredConsentState)) return false;
    lastConsentState = currentState;
    transferredConsentState = null;
    document.querySelectorAll('#shopify-pc__banner, #shopify-pc__prefs').forEach(function (element) {
      element.remove();
    });
    if (document.body) document.body.classList.remove('nb-cookie-prefs-open');
    document.documentElement.classList.remove('nb-cookie-consent-transfer-pending');
    return true;
  }

  function initializeConsentContinuity() {
    waitForCustomerPrivacy(function (customerPrivacy) {
      if (!transferredConsentState) {
        lastConsentState = consentStateFromVisitor(customerPrivacy);
        return;
      }

      var payload = {};
      ['analytics', 'marketing', 'preferences'].forEach(function (key) {
        if (typeof transferredConsentState[key] === 'boolean') payload[key] = transferredConsentState[key];
      });

      try {
        customerPrivacy.setTrackingConsent(payload, function () {
          finishTransferredConsent(customerPrivacy);
        });
        window.setTimeout(function () {
          if (transferredConsentState && !finishTransferredConsent(customerPrivacy)) {
            document.documentElement.classList.remove('nb-cookie-consent-transfer-pending');
          }
        }, 4000);
      } catch (_setConsentError) {
        document.documentElement.classList.remove('nb-cookie-consent-transfer-pending');
      }
    }, function () {
      document.documentElement.classList.remove('nb-cookie-consent-transfer-pending');
    });
  }

  function currentConsentTransferValue() {
    var customerPrivacy = window.Shopify && window.Shopify.customerPrivacy;
    var currentState = consentStateFromVisitor(customerPrivacy) || lastConsentState;
    if (currentState) lastConsentState = currentState;
    return encodeConsentState(currentState);
  }

  function isLocalizationForm(form) {
    if (!form || form.nodeType !== 1) return false;
    var action = String(form.getAttribute('action') || '');
    var formType = form.querySelector('input[name="form_type"]');
    return form.hasAttribute('data-nb-localization-form')
      || action.indexOf('/localization') !== -1
      || !!(formType && formType.value === 'localization');
  }

  function addConsentToReturnTo(form, encodedConsent) {
    if (!isLocalizationForm(form) || !encodedConsent) return '';
    var returnTo = form.querySelector('input[name="return_to"]');
    if (!returnTo) {
      returnTo = document.createElement('input');
      returnTo.type = 'hidden';
      returnTo.name = 'return_to';
      form.appendChild(returnTo);
    }
    try {
      var url = new URL(returnTo.value || (location.pathname + location.search + location.hash), location.origin);
      url.searchParams.set(consentTransferParam, encodedConsent);
      returnTo.value = url.pathname + url.search + url.hash;
      return returnTo.value;
    } catch (_returnToError) {
      return '';
    }
  }

  function prepareConsentForLocalization(form) {
    var encodedConsent = currentConsentTransferValue();
    if (!encodedConsent) return '';
    addConsentToReturnTo(form, encodedConsent);

    try {
      var currentUrl = new URL(window.location.href);
      currentUrl.searchParams.set(consentTransferParam, encodedConsent);
      window.history.replaceState(
        window.history.state,
        '',
        currentUrl.pathname + currentUrl.search + currentUrl.hash
      );
    } catch (_prepareConsentError) { }
    return encodedConsent;
  }

  function nordbeltDomainKind(hostname) {
    hostname = String(hostname || '').toLowerCase();
    if (/(^|\.)nordbelt\.nl$/.test(hostname)) return 'nl';
    if (/(^|\.)nordbelt\.com$/.test(hostname)) return 'com';
    return '';
  }

  function carryConsentToCrossDomainLink(event) {
    var link = event.target && event.target.closest ? event.target.closest('a[href]') : null;
    if (!link) return;
    try {
      var targetUrl = new URL(link.href, window.location.href);
      var currentDomain = nordbeltDomainKind(window.location.hostname);
      var targetDomain = nordbeltDomainKind(targetUrl.hostname);
      if (!currentDomain || !targetDomain || currentDomain === targetDomain) return;
      var encodedConsent = currentConsentTransferValue();
      if (!encodedConsent) return;
      targetUrl.searchParams.set(consentTransferParam, encodedConsent);
      link.href = targetUrl.toString();
    } catch (_linkConsentError) { }
  }

  function getCookieLocale() {
    var firstPathPart = location.pathname.toLowerCase().split('/').filter(Boolean)[0] || '';
    var pathLocale = firstPathPart.split('-')[0];
    if (copyByLocale[pathLocale]) return pathLocale;

    var countryParam = new URLSearchParams(location.search).get('country');
    var countrySelect = document.querySelector('select[name="country_code"]');
    var countryCode = (countryParam || (countrySelect && countrySelect.value) || '').toUpperCase();
    if (countryLocaleByCode[countryCode]) return countryLocaleByCode[countryCode];

    if (/\.nl$/i.test(location.hostname)) return 'nl';

    var documentLocale = (document.documentElement.lang || 'en').toLowerCase().split('-')[0];
    return copyByLocale[documentLocale] ? documentLocale : 'en';
  }

  function setLabelText(label, text) {
    if (!label) return;
    var textNode = Array.from(label.childNodes).find(function (node) {
      return node.nodeType === Node.TEXT_NODE;
    });
    if (textNode) textNode.nodeValue = text;
  }

  function compactCookieCopy() {
    var banner = document.querySelector('#shopify-pc__banner');
    if (!banner) return;

    var locale = getCookieLocale();
    if (banner.dataset.nbCompactLocale === locale) return;
    var copy = copyByLocale[locale] || copyByLocale.en;
    var uiCopy = uiCopyByLocale[locale] || uiCopyByLocale.en;
    var title = banner.querySelector('#shopify-pc__banner__body-title');
    var body = banner.querySelector('.shopify-pc__banner__body p');
    var manageButton = banner.querySelector('#shopify-pc__banner__btn-manage-prefs');
    var acceptButton = banner.querySelector('#shopify-pc__banner__btn-accept');
    var declineButton = banner.querySelector('#shopify-pc__banner__btn-decline');

    if (title) title.textContent = copy[0];
    if (body) body.textContent = copy[1];
    if (manageButton) manageButton.textContent = uiCopy[0];
    if (acceptButton) acceptButton.textContent = uiCopy[1];
    if (declineButton) declineButton.textContent = uiCopy[2];

    banner.dataset.nbCompactLocale = locale;
  }

  function compactPreferenceCopy() {
    var dialogs = document.querySelectorAll('#shopify-pc__prefs__dialog');
    if (!dialogs.length) return;

    var locale = getCookieLocale();
    var copy = preferenceCopyByLocale[locale] || preferenceCopyByLocale.en;
    var uiCopy = uiCopyByLocale[locale] || uiCopyByLocale.en;

    dialogs.forEach(function (dialog) {
      if (dialog.dataset.nbCompactLocale === locale) return;

      var introTitle = dialog.querySelector('.shopify-pc__prefs__intro-main h3');
      var introText = dialog.querySelector('.shopify-pc__prefs__intro-main p');
      var panelTitle = dialog.querySelector('#shopify-pc__prefs__header-title');
      var closeButton = dialog.querySelector('#shopify-pc__prefs__header-close');
      var acceptButton = dialog.querySelector('#shopify-pc__prefs__header-accept');
      var declineButton = dialog.querySelector('#shopify-pc__prefs__header-decline');
      var saveButton = dialog.querySelector('#shopify-pc__prefs__header-save');
      var optionSelectors = [
        '#shopify-pc__prefs__essential p',
        '#shopify-pc__prefs__preferences p',
        '#shopify-pc__prefs__marketing p',
        '#shopify-pc__prefs__analytics p'
      ];
      var optionLabelSelectors = [
        '#shopify-pc__prefs__essential label',
        '#shopify-pc__prefs__preferences label',
        '#shopify-pc__prefs__marketing label',
        '#shopify-pc__prefs__analytics label'
      ];

      if (panelTitle) panelTitle.textContent = (copyByLocale[locale] || copyByLocale.en)[0];
      if (closeButton) closeButton.setAttribute('aria-label', uiCopy[10]);
      if (acceptButton) acceptButton.textContent = uiCopy[3];
      if (declineButton) declineButton.textContent = uiCopy[4];
      if (saveButton) saveButton.textContent = uiCopy[5];
      if (introTitle) introTitle.textContent = copy[0];
      if (introText) introText.remove();
      optionSelectors.forEach(function (selector, index) {
        var optionText = dialog.querySelector(selector);
        if (optionText) optionText.textContent = copy[index + 1];
      });
      optionLabelSelectors.forEach(function (selector, index) {
        setLabelText(dialog.querySelector(selector), uiCopy[index + 6]);
      });

      dialog.dataset.nbCompactLocale = locale;
    });
  }

  function syncCookieUi() {
    compactCookieCopy();
    compactPreferenceCopy();
    document.body.classList.toggle('nb-cookie-prefs-open', !!document.querySelector('#shopify-pc__prefs__dialog'));
  }

  function closePreferenceOverlay() {
    document.querySelectorAll('#shopify-pc__prefs').forEach(function (preferences) {
      preferences.remove();
    });
    document.body.classList.remove('nb-cookie-prefs-open');
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('#shopify-pc__prefs__header-close, #shopify-pc__prefs__header-accept, #shopify-pc__prefs__header-decline, #shopify-pc__prefs__header-save')) {
      setTimeout(closePreferenceOverlay, 0);
    }
  }, true);

  document.addEventListener('visitorConsentCollected', function (event) {
    var state = consentStateFromEvent(event && event.detail);
    if (state) lastConsentState = state;
  });

  document.addEventListener('submit', function (event) {
    if (isLocalizationForm(event.target)) prepareConsentForLocalization(event.target);
  }, true);

  document.addEventListener('formdata', function (event) {
    if (!isLocalizationForm(event.target)) return;
    var encodedConsent = currentConsentTransferValue();
    if (!encodedConsent) return;
    var returnTo = addConsentToReturnTo(event.target, encodedConsent);
    if (returnTo && event.formData) event.formData.set('return_to', returnTo);
  }, true);

  document.addEventListener('pointerdown', carryConsentToCrossDomainLink, true);
  document.addEventListener('click', carryConsentToCrossDomainLink, true);

  initializeConsentContinuity();
  syncCookieUi();
  new MutationObserver(syncCookieUi).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
